import { useState, useEffect } from "react";
import "@/App.css";
import axios from "axios";
//import logo from "../public/images/DVXLogoBlackBg.png";
import { motion, AnimatePresence } from "framer-motion";
import { Toaster, toast } from "sonner";
import {
  Code2,
  Smartphone,
  Palette,
  BarChart3,
  Settings,
  Share2,
  Search,
  Menu,
  X,
  MessageCircle,
  Phone,
  Mail,
  MapPin,
  Send,
  ChevronRight,
  Quote,
  ExternalLink,
  Linkedin,
  Twitter,
  Instagram,
  Facebook,
  ArrowRight,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

//Old logo code start
// Logo Component - Modern Text Logo
// const Logo = ({ size = "default" }) => {
//   const sizeClasses = size === "large"
//     ? "text-3xl md:text-4xl"
//     : "text-xl md:text-2xl";

//   return (
//     <div className="flex items-center gap-2" data-testid="logo">
//       {/* Logo Icon */}
//       <div className="relative">
//         <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center transform rotate-6 hover:rotate-0 transition-transform duration-300">
//           <span className="text-white font-bold text-lg md:text-xl transform -rotate-6 hover:rotate-0 transition-transform duration-300">D</span>
//         </div>
//         <div className="absolute -bottom-1 -right-1 w-3 h-3 rounded-full bg-cyan-400 animate-pulse"></div>
//       </div>
//       {/* Logo Text */}
//       <div className="flex flex-col">
//         <span className={`font-bold tracking-tight ${sizeClasses}`}>
//           <span className="text-white">DEV</span>
//           <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">IXELX</span>
//         </span>
//         <span className="text-[10px] md:text-xs text-slate-500 tracking-[0.2em] uppercase -mt-1">Your Tech Dreams</span>
//       </div>
//     </div>
//   );
// };
//Old logo code end

//New logo code start
const Logo = ({ size = "default" }) => {
  const logoSize =
    size === "large"
      ? "h-16 md:h-20"
      : "h-10 md:h-12";

  return (
    <div className="flex items-center" data-testid="logo">
      {/* <img
        src={logo}
        alt="Devixelx Logo"
        className={`${logoSize} w-auto`}
      /> */}
      <img
        src="images/DVXLogoBlackBg.png"
        alt="DevixelX"
        className="h-12 w-auto"
      />
    </div>
  );
};
//New logo code end
// Navbar Component
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Services", href: "#services" },
    { name: "Testimonials", href: "#testimonials" },
    { name: "Contact", href: "#contact" },
  ];

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        className={`fixed top-0 left-0 right-0 z-50 navbar ${scrolled ? "scrolled glass" : ""
          }`}
        data-testid="navbar"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <a href="#" data-testid="logo-link">
              <Logo />
            </a>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-slate-300 hover:text-white transition-colors text-sm font-medium"
                  data-testid={`nav-${link.name.toLowerCase()}`}
                >
                  {link.name}
                </a>
              ))}
              <Button
                className="btn-primary px-6 py-2 rounded-full text-sm font-medium"
                onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })}
                data-testid="nav-cta-btn"
              >
                Get Started
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-white p-2"
              onClick={() => setMobileMenuOpen(true)}
              data-testid="mobile-menu-btn"
            >
              <Menu className="w-6 h-6" />
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="mobile-menu flex flex-col items-center justify-center"
            data-testid="mobile-menu"
          >
            <button
              className="absolute top-6 right-6 text-white p-2"
              onClick={() => setMobileMenuOpen(false)}
              data-testid="mobile-menu-close"
            >
              <X className="w-6 h-6" />
            </button>
            <div className="flex flex-col items-center gap-8">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-2xl font-medium text-white"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <Button
                className="btn-primary px-8 py-3 rounded-full text-lg font-medium mt-4"
                onClick={() => {
                  setMobileMenuOpen(false);
                  document.getElementById("contact").scrollIntoView({ behavior: "smooth" });
                }}
              >
                Get Started
              </Button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

// Hero Section
const Hero = () => {
  const stats = [
    { value: "25+", label: "Projects Delivered" },
    { value: "25+", label: "Happy Clients" },
    { value: "5+", label: "Years Experience" },
  ];

  return (
    <section className="hero-bg min-h-screen flex items-center pt-20" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/30 mb-6"
            >
              <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse"></span>
              <span className="text-sm text-blue-400 font-medium">Transforming Ideas into Reality</span>
            </motion.div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-6">
              <span className="gradient-text">Your Tech Dreams,</span>
              <br />
              <span className="text-white">Engineered to</span>
              <br />
              <span className="text-blue-400">Perfection</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-400 leading-relaxed mb-8 max-w-xl">
              We build scalable web solutions, mobile apps, and digital strategies
              that drive growth and transform your business vision into reality.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button
                className="btn-primary px-8 py-4 rounded-full text-base font-medium flex items-center gap-2"
                onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })}
                data-testid="hero-cta-primary"
              >
                Start Your Project
                <ArrowRight className="w-5 h-5" />
              </Button>
              <Button
                variant="outline"
                className="btn-secondary px-8 py-4 rounded-full text-base font-medium"
                onClick={() => document.getElementById("services").scrollIntoView({ behavior: "smooth" })}
                data-testid="hero-cta-secondary"
              >
                View Services
              </Button>
            </div>

            {/* Stats */}
            <div className="flex gap-8 md:gap-12">
              {stats.map((stat, index) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 + index * 0.1 }}
                  className="stat-item pr-8 md:pr-12"
                >
                  <div className="text-3xl md:text-4xl font-bold text-white mb-1">{stat.value}</div>
                  <div className="text-sm text-slate-500">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right Visual */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="relative hidden lg:block"
          >
            <div className="relative">
              {/* Floating Cards */}
              <motion.div
                animate={{ y: [0, -15, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                className="absolute -top-4 -left-4 glass-card rounded-2xl p-4 z-10"
              >
                <Code2 className="w-8 h-8 text-blue-400 mb-2" />
                <div className="text-white font-medium">Web Development</div>
                <div className="text-sm text-slate-400">React, Python, Node.js</div>
              </motion.div>

              <motion.div
                animate={{ y: [0, 15, 0] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 1 }}
                className="absolute -bottom-4 -right-4 glass-card rounded-2xl p-4 z-10"
              >
                <BarChart3 className="w-8 h-8 text-cyan-400 mb-2" />
                <div className="text-white font-medium">Digital Marketing</div>
                <div className="text-sm text-slate-400">SEO, PPC, Social</div>
              </motion.div>

              {/* Main Visual */}
              <div className="relative rounded-3xl overflow-hidden glow-blue">
                <div className="aspect-square bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl flex items-center justify-center">
                  <div className="grid grid-cols-3 gap-4 p-8">
                    {[Code2, Smartphone, Palette, BarChart3, Settings, Share2].map((Icon, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.6 + i * 0.1 }}
                        className="w-20 h-20 rounded-2xl bg-slate-800/50 border border-white/10 flex items-center justify-center hover:border-blue-500/50 transition-all cursor-pointer"
                      >
                        <Icon className="w-8 h-8 text-blue-400" />
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Services Section
const services = [
  {
    icon: Code2,
    title: "Web Development",
    desc: `Turn your ideas into powerful digital experiences. We design and develop high-quality, modern websites tailored to your business goals. Whether you need a simple landing page or a complex web application, we deliver solutions that are fast, scalable, and future-ready.

Using cutting-edge technologies like React, Node.js, and Python, we ensure your website is visually stunning, mobile-friendly, and built to perform—helping you stand out in the competitive digital world.

🚀 Modern UI • ⚡ Lightning-Fast • 🔒 Secure & Scalable`,
    span: "col-span-1 md:col-span-2 row-span-2",
    featured: true,
  },
  {
    icon: Smartphone,
    title: "Mobile App Development",
    desc: "Native and cross-platform mobile apps for iOS and Android that deliver exceptional user experiences.",
    span: "col-span-1 row-span-1",
  },
  {
    icon: Palette,
    title: "UI/UX Design",
    desc: "User-centric interfaces designed to convert visitors into customers.",
    span: "col-span-1 row-span-1",
  },
  {
    icon: BarChart3,
    title: "Digital Marketing",
    desc: "Data-driven marketing strategies including SEO, PPC, content marketing & social media to boost your online presence.",
    span: "col-span-1 md:col-span-2",
  },
  {
    icon: Settings,
    title: "Web Maintenance",
    desc: "From basic updates to complex e-commerce maintenance, we keep your website running smoothly 24/7.",
    span: "col-span-1",
  },
  {
    icon: Search,
    title: "SEO Optimization",
    desc: "Technical SEO, content optimization, and link building to improve your search rankings.",
    span: "col-span-1",
  },
  {
    icon: Share2,
    title: "Social Media Management",
    desc: "Strategic social media campaigns to build brand awareness and engage your audience.",
    span: "col-span-1",
  },
];

const Services = () => (
  <section id="services" className="py-24 md:py-32 relative" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-center mb-16"
      >
        <span className="text-sm font-medium uppercase tracking-widest text-blue-400 mb-4 block">
          What We Offer
        </span>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Services That <span className="gradient-text">Drive Growth</span>
        </h2>
        <p className="text-lg text-slate-400 max-w-2xl mx-auto">
          Comprehensive digital solutions tailored to your business needs,
          from development to marketing and beyond.
        </p>
      </motion.div>

      <div className="bento-grid">
        {services.map((service, index) => (
          <motion.div
            key={service.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className={`service-card glass-card rounded-2xl p-6 md:p-8 ${service.span}`}
            data-testid={`service-${service.title.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <service.icon className="service-icon w-10 h-10 md:w-12 md:h-12 text-blue-400 mb-4" />
            <h3 className="text-xl md:text-2xl font-semibold text-white mb-3">{service.title}</h3>
            <p className="text-slate-400 leading-relaxed">{service.desc}</p>
            {service.featured && (
              <Button
                variant="outline"
                className="mt-6 btn-secondary rounded-full px-6"
                onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })}
              >
                Learn More <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);


// Project Showcase Section new and techstack
const Projects = () => {
  const projects = [
    {
      title: "E-Commerce Platform",
      desc: "Modern online store with inventory management and payment gateway integration.",
      tech: ["React", "Node.js", "MongoDB", "Stripe"],
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=1200"
    },
    {
      title: "Healthcare Booking System",
      desc: "Patient appointment scheduling platform with doctor profiles and video consultations.",
      tech: ["Next.js", "Express", "PostgreSQL"],
      //image: "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?q=80&w=1200"
      image: "/images/fitsophysio.png",
      link: "https://fitsophysio.com/"
    },
    {
      title: "Interior & Painting Services Website",
      desc: "odern business website for interior design and painting services with service showcase, project gallery, and customer consultation features.",
      tech: ["React", "Firebase", "D3.js"],
      //image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1200"
      image: "/images/Smoravi.png",
      link: "https://www.smoravi.com"
    }
  ];

  return (
    <section className="py-24 md:py-32" id="projects">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-sm uppercase tracking-widest text-blue-400">
            OUR WORK
          </span>

          <h2 className="text-4xl md:text-5xl font-bold text-white mt-3">
            Featured <span className="gradient-text">Projects</span>
          </h2>
        </motion.div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-3 gap-8">

          {projects.map((project, i) => (

            <motion.div
              key={i}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="project-card rounded-2xl overflow-hidden group"
            >

              {/* Image */}
              <div className="relative overflow-hidden">

                <img
                  src={project.image}
                  alt={project.title}
                  onError={(e) => {
                    e.target.src =
                      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1200";
                  }}
                  className="w-full h-52 object-cover transition duration-500 group-hover:scale-110"
                />

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">

                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2 bg-blue-500 text-white rounded-full font-medium hover:bg-blue-600 transition"
                  >
                    View Project →
                  </a>

                </div>

              </div>

              {/* Content */}
              <div className="p-6">

                <h3 className="text-xl font-semibold text-white mb-2">
                  {project.title}
                </h3>

                <p className="text-slate-400 mb-4">
                  {project.desc}
                </p>

                <div className="flex flex-wrap gap-2">
                  {project.tech.map((tech, idx) => (
                    <span
                      key={idx}
                      className="text-xs bg-blue-500/10 text-blue-400 px-3 py-1 rounded-full"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

              </div>

            </motion.div>

          ))}

        </div>

      </div>

    </section>
  );
};


// Technology Stack Section New
const TechStack = () => {

  const tech = [
    { name: "React", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
    { name: "Next.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg" },
    { name: "Angular", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg" },
    { name: "Vue.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg" },
    { name: "Node.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
    { name: "Python", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
    { name: "MongoDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" },
    { name: "PostgreSQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" },
    { name: "MySQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" },
    { name: "PHP", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg" },
    { name: "Java", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg" },
    { name: ".NET", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dotnetcore/dotnetcore-original.svg" },
    { name: "Docker", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
    { name: "AWS", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg" },
    { name: "Firebase", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" },
    { name: "Tailwind", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg" },
    { name: "TypeScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" },
    { name: "JavaScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" }
  ];

  return (
    <section className="py-24 md:py-32 bg-[#02040a]">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-16">

          <span className="text-sm uppercase tracking-widest text-blue-400">
            TECHNOLOGIES
          </span>

          <h2 className="text-4xl md:text-5xl font-bold text-white mt-3">
            Our <span className="gradient-text">Technology Stack</span>
          </h2>

          <p className="text-slate-400 mt-4">
            We work with modern tools and technologies to deliver cutting-edge solutions.
          </p>

        </div>

        <div className="grid grid-cols-3 md:grid-cols-6 gap-8">

          {tech.map((item, i) => (

            <motion.div
              key={i}
              animate={{ y: [0, -12, 0] }}
              transition={{
                duration: 3 + i * 0.2,
                repeat: Infinity,
                ease: "easeInOut"
              }}
              whileHover={{
                scale: 1.15,
                y: -15
              }}
              className="tech-card group relative flex flex-col items-center justify-center rounded-xl p-6 border border-white/10 cursor-pointer"
            >

              {/* Glow */}
              <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition duration-300 bg-gradient-to-br from-blue-500/20 to-cyan-400/20 blur-xl"></div>

              {/* Icon */}
              <img
                src={item.icon}
                alt={item.name}
                className="w-12 h-12 mb-3 relative z-10 transition-transform duration-300 group-hover:scale-110"
              />

              {/* Name */}
              <p className="text-sm text-slate-300 relative z-10">
                {item.name}
              </p>

            </motion.div>

          ))}

        </div>

        <p className="text-center text-slate-500 mt-10">
          ...and many more technologies tailored to your project needs
        </p>

      </div>

    </section>
  );
};


// Testimonials Section
const testimonials = [
  {
    name: "Aarvik Sharma",
    role: "",
    content: "Devixelx transformed our online presence completely. Their team delivered a stunning e-commerce platform that increased our sales by 200%. Highly recommended!",
    avatar: "AS",
  },
  {
    name: "Vihaan Mehta",
    role: "",
    content: "The digital marketing strategy they developed for us was exceptional. Our organic traffic grew 5x in just 6 months. Professional and results-driven team.",
    avatar: "VM",
  },
  {
    name: "Reyansh Verma",
    role: "",
    content: "From web design to SEO, Devixelx handles everything flawlessly. They're not just developers, they're true partners in our digital success.",
    avatar: "RV",
  },
];

const Testimonials = () => (
  <section id="testimonials" className="py-24 md:py-32 relative" data-testid="testimonials-section">
    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-950/10 to-transparent"></div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <span className="text-sm font-medium uppercase tracking-widest text-blue-400 mb-4 block">
          Testimonials
        </span>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          What Our <span className="gradient-text">Clients Say</span>
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-8">
        {testimonials.map((testimonial, index) => (
          <motion.div
            key={testimonial.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.15 }}
            className="testimonial-card glass-card rounded-2xl p-8 relative"
            data-testid={`testimonial-${index}`}
          >
            <Quote className="w-10 h-10 text-blue-500/30 absolute top-6 right-6" />
            <p className="text-slate-300 leading-relaxed mb-6 relative z-10">
              "{testimonial.content}"
            </p>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-white font-semibold">
                {testimonial.avatar}
              </div>
              <div>
                <div className="font-semibold text-white">{testimonial.name}</div>
                <div className="text-sm text-slate-400">{testimonial.role}</div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

// Contact Section
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    service: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!formData.name || !formData.email || !formData.message) {
  //     toast.error("Please fill in all required fields");
  //     return;
  //   }
  //   setLoading(true);
  //   try {
  //     await axios.post(`${API}/contact`, formData);
  //     toast.success("Message sent successfully! We'll get back to you soon.");
  //     setFormData({ name: "", email: "", service: "", message: "" });
  //   } catch (error) {
  //     toast.error("Failed to send message. Please try again.");
  //   }
  //   setLoading(false);
  // };

  const validateForm = () => {
  let newErrors = {};

  if (!formData.name.trim()) {
    newErrors.name = "Name is required";
  }

  if (!formData.email.trim()) {
    newErrors.email = "Email is required";
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
  ) {
    newErrors.email = "Invalid email address";
  }

  // if (!formData.service) {
  //   newErrors.service = "Please select a service";
  // }

  if (!formData.message.trim()) {
    newErrors.message = "Message is required";
  } else if (formData.message.length < 10) {
    newErrors.message = "Message must be at least 10 characters";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

// const handleSubmit = (e) => {
//   e.preventDefault();

//   if (!validateForm()) {
//     toast.error("Please fix form errors before submitting");
//     return;
//   }

//   const { name, email, service, message } = formData;

//   const subject = `New Inquiry from ${name}`;

//   const body = `
// Name: ${name}
// Email: ${email}
// Service: ${service}

// Message:
// ${message}
// `;

//   const mailtoLink = `mailto:devixelx@gmail.com?subject=${encodeURIComponent(
//     subject
//   )}&body=${encodeURIComponent(body)}`;

//   window.location.href = mailtoLink;

//   setFormData({
//     name: "",
//     email: "",
//     service: "",
//     message: "",
//   });

//   setErrors({});
// };


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) {
    toast.error("Please fix form errors before submitting");
    return;
  }

  setLoading(true);

  try {
    const response = await axios.post(`${API}/contact`, formData);

    if (response.data.success) {
      toast.success("Message sent successfully! We'll contact you soon.");

      setFormData({
        name: "",
        email: "",
        service: "",
        message: "",
      });

      setErrors({});
    }
  } catch (error) {
    console.error(error);

    toast.error(
      error.response?.data?.detail ||
      "Unable to send message. Please try again."
    );
  } finally {
    setLoading(false);
  }
};


  const contactInfo = [
    { icon: Mail, label: "Email", value: "info@devixelx.com", href: "mailto:info@devixelx.com" },
    {
      icon: Phone,
      label: "Phone",
      phones: [
        { number: "+91 9022215980", href: "tel:+919022215980" },
        { number: "+91 9967530647", href: "tel:+919967530647" },
      ],
    },
    { icon: MapPin, label: "Location", value: "Mumbai, India", href: "#" },
  ];

  return (
    <section id="contact" className="py-24 md:py-32 relative" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-sm font-medium uppercase tracking-widest text-blue-400 mb-4 block">
            Get In Touch
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Let's Build Something <span className="gradient-text">Amazing</span>
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Ready to start your project? Contact us today and let's discuss how we can help.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="space-y-6 mb-10">
              {contactInfo.map((info) => (
                <div
                  key={info.label}
                  className="flex items-center gap-4 p-4 glass-card rounded-xl hover:border-blue-500/50 transition-all group"
                  data-testid={`contact-${info.label.toLowerCase()}`}
                >
                  <div className="w-12 h-12 rounded-full bg-blue-500/10 flex items-center justify-center group-hover:bg-blue-500/20 transition-colors">
                    <info.icon className="w-5 h-5 text-blue-400" />
                  </div>

                  <div>
                    <div className="text-sm text-slate-400">{info.label}</div>

                    {/* If Phone → show multiple numbers */}
                    {info.phones ? (
                      <div className="flex flex-col gap-1">
                        {info.phones.map((phone, index) => (
                          <a
                            key={index}
                            href={phone.href}
                            className="text-white font-medium hover:text-blue-400"
                          >
                            {phone.number}
                          </a>
                        ))}
                      </div>
                    ) : (
                      <a href={info.href} className="text-white font-medium">
                        {info.value}
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>


            {/* Social Links */}
            <div>
              <div className="text-sm text-slate-400 mb-4">Follow Us</div>
              {/* <div className="flex gap-4">
                {[
                  { icon: Linkedin, href: "", label: "LinkedIn" },
                  { icon: Twitter, href: "https://x.com/DevixelX", label: "Twitter" },
                  { icon: Instagram, href: "https://www.instagram.com/devixelx", label: "Instagram" },
                  { icon: Facebook, href: "https://www.facebook.com/profile.php?id=61588152522612&mibextid=wwXIfr", label: "Facebook" },
                ].map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    className="w-10 h-10 rounded-full bg-slate-800 border border-white/10 flex items-center justify-center hover:border-blue-500/50 hover:bg-blue-500/10 transition-all"
                    data-testid={`social-${social.label.toLowerCase()}`}
                  >
                    <social.icon className="w-4 h-4 text-slate-400" />
                  </a>
                ))}
              </div> */}
              <div className="flex gap-4">
                {[
                  { icon: Linkedin, href: "https://www.linkedin.com/company/devixelx/", label: "LinkedIn" },
                  { icon: Twitter, href: "https://x.com/DevixelX", label: "Twitter" },
                  { icon: Instagram, href: "https://www.instagram.com/devixelx", label: "Instagram" },
                  { icon: Facebook, href: "https://www.facebook.com/profile.php?id=61588152522612&mibextid=wwXIfr", label: "Facebook" },
                ].map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-slate-800 border border-white/10 flex items-center justify-center hover:border-blue-500/50 hover:bg-blue-500/10 transition-all"
                    data-testid={`social-${social.label.toLowerCase()}`}
                  >
                    <social.icon className="w-4 h-4 text-slate-400" />
                  </a>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
              <div className="grid sm:grid-cols-2 gap-6">
                <div>
                  <label className="text-sm text-slate-400 mb-2 block">Your Name *</label>
                  <Input
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="form-input bg-slate-900/50 border-white/10 text-white placeholder:text-slate-500 h-12 rounded-xl"
                    data-testid="contact-name-input"
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                  )}
                </div>
                <div>
                  <label className="text-sm text-slate-400 mb-2 block">Email Address *</label>
                  <Input
                    type="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="form-input bg-slate-900/50 border-white/10 text-white placeholder:text-slate-500 h-12 rounded-xl"
                    data-testid="contact-email-input"
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                  )}
                </div>
              </div>

              <div>
                <label className="text-sm text-slate-400 mb-2 block">Service Interested In</label>
                <Select
                  value={formData.service}
                  onValueChange={(value) => setFormData({ ...formData, service: value })}
                >
                  <SelectTrigger
                    className="form-input bg-slate-900/50 border-white/10 text-white h-12 rounded-xl"
                    data-testid="contact-service-select"
                  >
                    <SelectValue placeholder="Select a service" />
                  </SelectTrigger>
                  <SelectContent className="bg-slate-900 border-white/10">
                    <SelectItem value="web-development">Web Development</SelectItem>
                    <SelectItem value="mobile-app">Mobile App Development</SelectItem>
                    <SelectItem value="ui-ux">UI/UX Design</SelectItem>
                    <SelectItem value="digital-marketing">Digital Marketing</SelectItem>
                    <SelectItem value="seo">SEO Optimization</SelectItem>
                    <SelectItem value="maintenance">Web Maintenance</SelectItem>
                    <SelectItem value="social-media">Social Media Management</SelectItem>
                    <SelectItem value="other">Other</SelectItem>
                  </SelectContent>
                </Select>
                {/* {errors.service && (
                  <p className="text-red-500 text-sm mt-1">{errors.service}</p>
                )} */}
              </div>

              <div>
                <label className="text-sm text-slate-400 mb-2 block">Your Message *</label>
                <Textarea
                  placeholder="Tell us about your project..."
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="form-input bg-slate-900/50 border-white/10 text-white placeholder:text-slate-500 min-h-[150px] rounded-xl resize-none"
                  data-testid="contact-message-input"
                />
                {errors.message && (
                  <p className="text-red-500 text-sm mt-1">{errors.message}</p>
                )}
              </div>

              <Button
                type="submit"
                disabled={loading}
                className="btn-primary w-full py-4 rounded-full text-base font-medium flex items-center justify-center gap-2"
                data-testid="contact-submit-btn"
              >
                {loading ? (
                  "Sending..."
                ) : (
                  <>
                    Send Message
                    <Send className="w-4 h-4" />
                  </>
                )}
              </Button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => (
  <footer className="py-12 border-t border-white/10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <Logo />
        <p className="text-slate-400 text-sm text-center md:text-left">
          © {new Date().getFullYear()} Devixelx. All rights reserved. Your Tech Dreams.
        </p>
        <div className="flex gap-6">
          <a href="#" className="text-sm text-slate-400 hover:text-white transition-colors">Privacy</a>
          <a href="#" className="text-sm text-slate-400 hover:text-white transition-colors">Terms</a>
        </div>
      </div>
    </div>
  </footer>
);

// WhatsApp Button
const WhatsAppButton = () => (
  <a
    href="https://wa.me/919137159935?text=Hi%20Devixelx!%20I'm%20interested%20in%20your%20services."
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-btn"
    data-testid="whatsapp-btn"
  >
    <svg viewBox="0 0 24 24" className="w-7 h-7 text-white fill-current">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
    </svg>
  </a>
);

// Live Chat Widget
const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { type: "bot", text: "Hi! 👋 Welcome to Devixelx. How can I help you today?" },
  ]);
  const [input, setInput] = useState("");

  const sendMessage = () => {
    if (!input.trim()) return;
    setMessages([...messages, { type: "user", text: input }]);
    setInput("");
    // Simulate bot response
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          type: "bot",
          text: "Thanks for your message! Our team will get back to you shortly. You can also email us at hello@devixelx.com or call us directly.",
        },
      ]);
    }, 1000);
  };

  return (
    <>
      {/* Chat Toggle Button */}
      {/* <button
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        className="fixed bottom-24 right-6 z-[60] w-14 h-14 rounded-full bg-blue-500 flex items-center justify-center shadow-lg hover:bg-blue-600 transition-colors cursor-pointer"
        data-testid="chat-toggle-btn"
        aria-label={isOpen ? "Close chat" : "Open chat"}
      >
        {isOpen ? <X className="w-6 h-6 text-white" /> : <MessageCircle className="w-6 h-6 text-white" />}
      </button> */}

      {/* Chat Window */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            className="chat-widget"
            data-testid="chat-widget"
          >
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-500 p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  <MessageCircle className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="text-white font-semibold">Devixelx Support</div>
                  <div className="text-blue-100 text-sm">We typically reply instantly</div>
                </div>
              </div>
            </div>

            {/* Messages */}
            <div className="h-72 overflow-y-auto p-4 space-y-4">
              {messages.map((msg, i) => (
                <div key={i} className={`flex ${msg.type === "user" ? "justify-end" : "justify-start"}`}>
                  <div
                    className={`max-w-[80%] rounded-2xl px-4 py-2 ${msg.type === "user"
                      ? "bg-blue-500 text-white rounded-br-sm"
                      : "bg-slate-800 text-slate-200 rounded-bl-sm"
                      }`}
                  >
                    {msg.text}
                  </div>
                </div>
              ))}
            </div>

            {/* Input */}
            <div className="p-4 border-t border-white/10">
              <div className="flex gap-2">
                <Input
                  placeholder="Type a message..."
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && sendMessage()}
                  className="bg-slate-800 border-white/10 text-white placeholder:text-slate-500"
                  data-testid="chat-input"
                />
                <Button
                  onClick={sendMessage}
                  className="bg-blue-500 hover:bg-blue-600"
                  data-testid="chat-send-btn"
                >
                  <Send className="w-4 h-4" />
                </Button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

// Main App Component
function App() {
  return (
    <div className="App min-h-screen bg-[#02040a]">
      <Toaster position="top-right" richColors />
      <Navbar />
      <Hero />
      <div className="section-divider"></div>
      <Services />
      <Projects />
      <TechStack />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <ChatWidget />
    </div>
  );
}

export default App;
